import React from "react";

import { Trans } from "@lingui/react/macro";

import Stack from "@readai/pulse/components/Stack";

import EventNotification, {
  EventNotificationDescription,
  EventNotificationTitle,
  ReturnToRead,
} from "@app/booking/components/EventNotification";

const InvalidEvent = () => (
  <EventNotification>
    <Stack spacing={1}>
      <EventNotificationTitle>
        <Trans>The event you’re trying to view no longer exists.</Trans>
      </EventNotificationTitle>
      <EventNotificationDescription>
        <Trans>
          Please reach out to the calendar owner for a new scheduling link or
          more information.
        </Trans>
      </EventNotificationDescription>
    </Stack>
    <ReturnToRead />
  </EventNotification>
);

export default InvalidEvent;
